import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const ItemService = {
    /**
     * Get items by user (or perform any items post query)
     * @param {Object} params
     * @param {string} params.token
     * @param {Object} params.dataObj
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    postQuery: async ({
        token = '',
        dataObj = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'ItemService.postQuery';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.items}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Get item by id
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getById: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'ItemService.getById';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.get({
                url: `${urls?.url}${urls?.apiV1}${urls?.items}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Edit item
     * @param {Object} params
     * @param {Object} params.item
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    edit: async ({
        item = {},
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'ItemService.edit';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.items}/${item?.id}`,
                data: item,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },
};
